import React from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { makePath } from 'helpers/link-generation';
import { bem } from 'helpers/class-name';
import { PFE_ICONS } from 'constants/icons';
import { Dropdown, DropdownItem, DropdownMenu } from 'components/Dropdown2';
import Message from 'components/Message';
import messages from '../../Schedules.messages';
import './SchedulePreview.scss';

const { element } = bem('schedule-preview');

const DROPDOWN_ITEMS = [
  {
    key: 'EDIT_SCHEDULE_INSTANCE',
    render: (venueId, scheduleId, recurrenceDate) => (
      <Message
        as={Link}
        className={element('edit-link')}
        to={makePath.scheduleInstanceEdit({
          venueId,
          scheduleId,
          occurrenceDate: recurrenceDate,
        })}
        message={messages.board.preview.editScheduleInstance}
      />
    ),
    action: () => {},
  },
  {
    key: 'CANCEL_SCHEDULE_INSTANCE',
    render: () => (
      <Message className={element('cancel-link')} message={messages.board.preview.cancelScheduleInstance} />
    ),
    action: ({ openModal, activeSchedule, cancelScheduleInstance }) =>
      openModal('CancelScheduleModal', { activeSchedule, cancelSchedule: cancelScheduleInstance }),
  },
];

const SchedulePreviewActions = props => {
  const intl = useIntl();
  const {
    venueId,
    activeSchedule: { scheduleId, recurrenceDate },
  } = props;

  return (
    <Dropdown attachment="right">
      {({ toggleMenu }) => (
        <>
          <button
            type="button"
            aria-label={intl.formatMessage(messages.board.preview.moreOptions)}
            onClick={toggleMenu}>
            <Isvg src={PFE_ICONS.threeDots} />
          </button>
          <DropdownMenu>
            {DROPDOWN_ITEMS.map(item => (
              <DropdownItem key={item.key} onClick={() => item.action(props)}>
                {item.render(venueId, scheduleId, recurrenceDate)}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </>
      )}
    </Dropdown>
  );
};

SchedulePreviewActions.propTypes = {
  venueId: PropTypes.number,
  activeSchedule: PropTypes.shape({
    scheduleName: PropTypes.string,
    startDateTime: PropTypes.instanceOf(Date),
    scheduleId: PropTypes.number,
    recurrenceDate: PropTypes.string,
  }),
};

export default SchedulePreviewActions;
